import { render, staticRenderFns } from "./ScannedCouponsTable.vue?vue&type=template&id=dc037a46&"
import script from "./ScannedCouponsTable.vue?vue&type=script&lang=js&"
export * from "./ScannedCouponsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports